import { render, staticRenderFns } from "./MedicineTrackerComponent.vue?vue&type=template&id=32232238&"
import script from "./MedicineTrackerComponent.vue?vue&type=script&lang=ts&"
export * from "./MedicineTrackerComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MedicineTrackerComponent.vue?vue&type=style&index=0&id=32232238&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports